<div class="bg-color pb-5">
    <ng-container *ngFor="let panel of panels">
        <app-image *ngIf="panel.template !== 'card'" [comicData]="panel" [notificationColumn]="notificationColumn"></app-image>
        <app-template-card *ngIf="panel.template === 'card'" [data]="panel" [customStyles]="{'hideBorder': true, descriptionLH: 'normal'}"></app-template-card>
    </ng-container>
</div>
